<template>
    <div class="p-col-12">
        <page-header title="forms.type-service.title"/>
        <form @submit.prevent="save">
            <card :header="$t('forms.type-service.card-title-information')" class="p-col-12">
              <coff-input-text v-model="form.name" label="forms.type-service.name" class="p-col-12 p-md-6 p-lg-4" :error="validation.name" />
              <coff-input-number v-model="form.price" label="forms.type-service.price" class="p-col-12 p-md-5 p-lg-3" :error="validation.price" />

              <coff-input-radio v-model="form.active" @update="forceUpdateField('active', $event)" :options="options" label="forms.type-service.isActive" class="p-col-12 p-md-4 p-lg-2" :error="validation.active"/>

              <hr style="width: 100%;"/>

              <coff-input-auto-complete v-if="letters" v-model="form.headerLetter" label="forms.type-service.header-letter" class="p-col-12 p-md-5 p-lg-3" field="name" :func-suggestions="searchLetter" :dropdown="true"/>

              <coff-input-auto-complete v-if="letters" v-model="form.footerLetter" label="forms.type-service.footer-letter" class="p-col-12 p-md-5 p-lg-3" field="name" :func-suggestions="searchLetter" :dropdown="true"/>

              <hr style="width: 100%;"/>

              <coff-input-select v-model="form.contract" label="forms.type-service.contracts" class="p-col-12 p-md-5 p-lg-3" :options="contracts" />
              <coff-input-auto-complete v-if="typeServices" v-model="form.defaultTypeServiceUnderage" label="forms.type-service.default-type-service-underage" class="p-col-12 p-md-5 p-lg-3" :itens="typeServices" field="name" :func-suggestions="searchTypeService" :dropdown="true"/>

              <hr style="width: 100%;"/>

              <TabView class="p-col-12" ref="tabs" :tab="2">
                <TabPanel id="NORMAL" :header="$t('forms.type-service.normal')" :active="form.typeBilling === 'NORMAL'">
                  <div class="p-grid">
                    <coff-input-radio v-model="form.haveDiscount" @update="forceUpdateField('haveDiscount', $event)" :options="options" label="forms.type-service.have-discount" class="p-col-6 p-md-3 p-lg-2" :error="validation.haveDiscount"/>
                    <template v-if="form.haveDiscount">
                      <coff-input-radio v-model="form.cumulativeDiscount" @update="forceUpdateField('cumulativeDiscount', $event)" :options="options" label="forms.type-service.cumulative-discount" class="p-col-6 p-md-3 p-lg-2" :error="validation.cumulativeDiscount"/>

                      <coff-input-radio v-model="form.discountPerClient" @update="forceUpdateField('discountPerClient', $event)" :options="options" label="forms.type-service.discount-per-client" class="p-col-6 p-md-3 p-lg-2" :error="validation.discountPerClient"/>

                      <coff-input-select v-model="form.typeDiscount" label="forms.type-service.type-discount" class="p-col-12 p-md-4 p-lg-6" :options="typesTypeDiscount" :error="validation.stage" :translate="true" option-value="id"/>
                      <coff-input-number v-model="form.amountToDiscount" label="forms.type-service.amount-to-discount" class="p-col-12 p-md-6 p-lg-6" :error="validation.amountToDiscount" :minFractionDigits="0"/>
                      <coff-input-number v-model="form.discount" label="forms.type-service.discount" class="p-col-12 p-md-6 p-lg-6" :error="validation.discount" :additional-translate="additionalTranslate" />

                    </template>
                  </div>
                </TabPanel>
                <TabPanel id="ADDITIVE" :header="$t('forms.type-service.additive')" :active="form.typeBilling === 'ADDITIVE'">
                  <div class="p-grid">
                    <coff-input-text v-model="form.additivePerClient" label="forms.type-service.additive-per-client" class="p-col-12 p-md-5 p-lg-3" :error="validation.additivePerClient" />
                  </div>
                </TabPanel>
                <TabPanel id="SHARED" :header="$t('forms.type-service.shared')" :active="form.typeBilling === 'SHARED'">
                  <div class="p-grid">
                    <coff-input-radio v-model="form.sharedValue" @update="forceUpdateField('sharedValue', $event)" :options="options" label="forms.type-service.shared-value" class="p-col-6 p-md-4 p-lg-3" :error="validation.sharedValue"/>
                  </div>
                </TabPanel>
              </TabView>

              <hr />

              <coff-input-text-editor v-model="form.budget" label="forms.type-service.budget" class="p-col-12"/>

            </card>
            <div class="p-col-12">
                <Button :label="$t('btn.save&continue')" class="p-button-success" style="float: right;"/>
            </div>
        </form>
    </div>
</template>

<script>

    import ValidationUtils from "@/utils/ValidationUtils";
    import ToastMessageBusiness from "@/business/ToastMessageBusiness";
    import EventBus from "@/commons/EventBus";
    import PageHeader from "@/components/page/PageHeader";
    import TypeServiceBusiness from "@/business/TypeServiceBusiness";
    import LetterBusiness from "@/business/LetterBusiness";
    import ContractBusiness from "@/business/ContractBusiness";

    export default {
        name: "TypeServiceForm",
        components: {PageHeader},
        data(){
            return {
                form: {
                  typeBilling: 'NORMAL',
                  haveDiscount: false,
                  contracts: [],
                },
                validation: {
                  name: false,
                  price: false,
                  active: false,
                  typeBilling: false,
                },
                normalExtraValidations:{
                  cumulativeDiscount: false,
                  amountToDiscount: false,
                  typeDiscount: false,
                  discount: false,
                  discountPerClient: false,
                  haveDiscount: false,
                },
                additiveExtraValidations:{
                  additivePerClient: false,
                },
                sharedExtraValidations:{
                  sharedValue: false,
                },
                options: [
                    {value: true, label: 'field.default.yes'},
                    {value: false, label: 'field.default.no'}
                ],
                typesTypeDiscount: TypeServiceBusiness.getTypeDiscount(),
                letters: null,
                contracts: [],
                typeServices: null,
            }
        },

        computed:{

          additionalTranslate(){
            return this.form?.typeDiscount ? {typeDiscount: (this.form?.typeDiscount?.id === 'PERCENT' ? '(%)' : `(${this.$t('field.default.coin')})`) } : {};
          }

        },

        async mounted(){
            const id = this.$route.params.id;
            this.$refs.tabs.$on('tab-change', this.changeTab);
            if(id){
                EventBus.loadingPage(true);
                this.form =  {... await TypeServiceBusiness.getById(id)};
                this.$refs.tabs.tabs.forEach(tab => {
                  if(tab.$attrs.id === this.form.typeBilling){
                    this.$refs.tabs.activateTab(tab);
                  }
                });
                EventBus.loadingPage(false);
            }
            this.typeServices = await this.searchTypeService();
            this.letters =  await this.searchLetter();
            this.contracts =  await ContractBusiness.getAll();
        },
        methods:{

          forceUpdateField(field, value){
            this.$set(this.form, field, value);
          },

          cleanExtraValidation(extraValidationList){
            Object.keys(this[extraValidationList]).forEach(key => {
              delete this.validation[key];
            });
          },

          async validNormalExtraValidations(){
            if(this.form.haveDiscount){
              this.validation = {...this.validation, ...this.normalExtraValidations};
            } else {
              this.cleanExtraValidation('normalExtraValidations');
            }
            this.cleanExtraValidation('additiveExtraValidations');
            this.cleanExtraValidation('sharedExtraValidations');
          },

          async validAdditionalExtraValidations(){
            this.validation = {...this.validation, ...this.additiveExtraValidations};
            this.cleanExtraValidation('normalExtraValidations');
            this.cleanExtraValidation('sharedExtraValidations');
          },

          async validSharedExtraValidations(){
            this.validation = {...this.validation, ...this.sharedExtraValidations};
            this.cleanExtraValidation('normalExtraValidations');
            this.cleanExtraValidation('additiveExtraValidations');
          },

          async formValidation(){
            switch (this.form.typeBilling){
              case 'NORMAL' : await this.validNormalExtraValidations(); break;
              case 'ADDITIVE' : await this.validAdditionalExtraValidations(); break;
              case 'SHARED' : await this.validSharedExtraValidations(); break;
            }
            this.validation = ValidationUtils.basicValidation(this.validation, this.form);
          },

          async save(){
              await this.formValidation();
              if(!this.validation.erros){
                  const response = await TypeServiceBusiness.save(this.form, this.form.id).catch((e) => ToastMessageBusiness.showError(e.message));
                  if(response){
                      this.form = response;
                      ToastMessageBusiness.showSuccess();
                  }
              }
          },

          changeTab(event){
            this.form.typeBilling = event.tab.$attrs.id;
          },

          async searchLetter(name){
            return await LetterBusiness.searchByName(name);
          },

          async searchTypeService(name){
              const response = await TypeServiceBusiness.searchByName(name);
              return response.filter(ts => ts.id !== this.form.id);
          },

        }
    }
</script>

<style scoped>

</style>
